import React from "react";
import { env } from '../../env';
import { Divider } from "antd";
import "./Home.scss";
// import CookieConsent from "react-cookie-consent";
import Table from 'react-bootstrap/Table';

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
  }

  openModel = () => this.setState({ isOpen: true });
  closeModel = () => this.setState({ isOpen: false });
  render() {
    return (
      <div className="container main">
        <h1>About APInet</h1>
        <Divider />
        <div className="row">
          <div className="col-md-6">
            <div className="purpose">
              <p>Understanding protein-protein interactions (PPIs) between different hosts and pathogens is a crucial part in the different breakthroughs in research about infectious diseases. Pathogens resort to diverse mechanisms that affect the host's cellular processes, causing multiple disorders that are often harmful for the infected individual. However, specialized systems that collect PPI data are limited, making this task more difficult for researchers. APInet is a robust protein-protein interactions (PPI) database that predicts the interactions between 12 animal species and some of their fungal, bacterial and viral pathogens employing four different methods: Interolog-based mapping, domain-based mapping, gene ontology semantic similarity, and phylogenetic profiling, which can be queried individually or by finding a consensus between two or more of these methods, minimizing false positives, while providing insights into various interaction mechanisms. Additionally, our database also provides RNA-Seq analyses for select host-pathogen pairs, further enhancing the understanding on the interactions between those species.
              </p>
            </div>
          </div>
          <div className="col-md-6">
            <img src={`${process.env.PUBLIC_URL}/images/abstract.svg`} alt="" width={600} className="container" />
          </div>
        </div>
        <Divider />
        <h1>Search by animal hosts</h1>

        <Table responsive className="kbl-table table-borderless">
          <thead className="kbl-thead">
            <tr>
              <th >Animal Species</th><th>Common Name </th><th> Proteins</th> <th> Gene Ontology </th> <th> KEGG Pathways </th> <th> Transcription Factors </th> <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td> <i>Homo sapiens</i> </td> <td>Human</td> <td>136,194</td><td>1,692,437</td><td>112,095</td>
              <td>38,313</td> <td><a href={`${env.BASE_URL}/hosts/?id=1`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Canis lupus familiaris</i> </td> <td>Dog</td> <td>63,650</td><td>780,261</td><td>50,782</td>
              <td>26,476</td> <td><a href={`${env.BASE_URL}/hosts/?id=2`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Felis catus</i> </td> <td>Cat</td><td>71,463</td><td>952,482</td><td>58,044</td>
              <td>1,594</td> <td><a href={`${env.BASE_URL}/hosts/?id=3`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Sus scrofa</i> </td> <td>Pig</td> <td>63,575</td><td>869,256</td><td>52,982</td>
              <td>6,806</td> <td><a href={`${env.BASE_URL}/hosts/?id=4`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Bos taurus</i> </td> <td>Cattle</td> <td>64,939</td><td>836,992</td><td>53,022</td>
              <td>7,494</td><td><a href={`${env.BASE_URL}/hosts/?id=5`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Gallus gallus</i> </td> <td>Chicken</td> <td>68,683</td><td>899,448</td><td>54,597</td>
              <td>12,181</td> <td><a href={`${env.BASE_URL}/hosts/?id=6`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Capra hircus  </i> </td> <td>Goat</td> <td>42,653</td><td>578,869</td><td>35,613</td>
              <td>3,703</td> <td><a href={`${env.BASE_URL}/hosts/?id=7`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Ovis aries</i> </td> <td>Sheep</td> <td>76,701</td><td>1,015,102</td><td>64,650</td>
              <td>4,806</td> <td><a href={`${env.BASE_URL}/hosts/?id=8`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Equus caballus</i> </td> <td>Horse</td> <td>60,900</td><td>823,082</td><td>50,176</td>
              <td>3,114</td> <td><a href={`${env.BASE_URL}/hosts/?id=9`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Bos grunniens</i> </td> <td>Domestic Yak</td> <td>64,939</td><td>535,547</td><td>33,385</td>
              <td>2,542</td><td><a href={`${env.BASE_URL}/hosts/?id=10`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Bubalus bubalis</i> </td> <td>Water Buffalo</td> <td>64,378</td><td>875,757</td><td>53,177</td>
              <td>59,720</td> <td><a href={`${env.BASE_URL}/hosts/?id=11`}>Get interactions</a></td>
            </tr>
            <tr>
              <td> <i>Apis melifera</i> </td> <td>Honey Bee</td> <td>23,471</td><td>288,544</td><td>16,366</td>
              <td>20,503</td> <td><a href={`${env.BASE_URL}/hosts/?id=12`}>Get interactions</a></td>
            </tr>
          </tbody>
        </Table>
        <Divider />

        <div className="row flex-lg-row justify-content-center g-2 my-2">
          <h1>Data Sources</h1>
        </div>

        <div className="row flex-lg-row justify-content-center g-2 my-2">
          <table>
            <tbody>
              <tr>
                <td>
                  <a
                    href="https://hpidb.igbb.msstate.edu/"
                    className="col-md-1 hpidb"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/hpidb.png`} alt="HPIDB" />
                  </a>
                </td>
                <td>
                  <a
                    href="http://www.ebi.ac.uk/intact/"
                    className="col-md-1 db"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/intact.png`} height='40px' width='80px' alt="IntAct" />
                  </a>
                </td>
                <td>
                  <a
                    href="http://mint.bio.uniroma2.it"
                    className="col-md-1 db"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/mint.png`} alt="MINT" />
                  </a>
                </td>
                <td>
                  <a
                    href="https://thebiogrid.org/"
                    className="col-md-1 db"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/biogrid.png`} alt="BioGRID" />
                  </a>
                </td>
                <td>
                  <a
                    href="https://string-db.org/"
                    className="col-md-1 db"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/string.png`} alt="STRING" />
                  </a>
                </td>
                <td>
                  <a
                    href="https://virhostnet.prabi.fr/"
                    className="col-md-1 db"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/virhostnet.svg`} alt="VirHostNet" />
                  </a>
                </td>
                <td>
                  <a
                    href="https://manticore.niehs.nih.gov/cgi-bin/Domine"
                    className="col-md-1 db2"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/domine.png`} alt="DOMINE" />
                  </a>
                </td>
                <td>
                  <a
                    href="https://3did.irbbarcelona.org/"
                    className="col-md-1 hpidb"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={`${process.env.PUBLIC_URL}/images/3did.png`} alt="3DID" />
                  </a>
                </td>
              </tr>
              <tr>
                <td>
                  <a href="https://hpidb.igbb.msstate.edu/">HPIDB</a>
                </td>
                <td>
                  <a href="http://www.ebi.ac.uk/intact/">IntAct</a>
                </td>
                <td>
                  <a href="http://mint.bio.uniroma2.it">MINT</a>
                </td>
                <td>
                  <a href="https://thebiogrid.org/">BioGRID</a>
                </td>
                <td>
                  <a href="https://string-db.org/">STRING</a>
                </td>
                <td>
                  <a href="https://virhostnet.prabi.fr/">VirHostNet</a>
                </td>
                <td>
                  <a href="https://manticore.niehs.nih.gov/cgi-bin/Domine">DOMINE</a>
                </td>
                <td>
                  <a href="https://3did.irbbarcelona.org/">3DID</a>
                </td>
              </tr>
            </tbody>
          </table>

          {/* <a
            href="http://www.uniprot.org/"
            className="col-md-1 db"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../images/uniprot.png" alt="" />
            <figcaption>UniProt</figcaption>
          </a>
          <a
            href="https://ensembl.org"
            className="col-md-1 hpidb"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src="../images/ensembl.png" alt="" />
            <figcaption>ENSEMBL</figcaption>
          </a> */}
        </div>
        <Divider />
      </div>
    )
  }
}